// Helix Go — phone detection and the per-device "stay on the full site" preference.
// The preference lives in localStorage so it is per-device, never written to the DB.

const STAY_KEY = "helix.go.full-site";

/** True when this device looks like a phone: narrow viewport AND coarse pointer. */
export function isPhoneDevice(): boolean {
  if (typeof window === "undefined") return false;
  const coarse = typeof window.matchMedia === "function" && window.matchMedia("(pointer: coarse)").matches;
  return coarse && window.innerWidth < 768;
}

/** Per-device opt-out: user tapped "Full site" in Helix Go. */
export function getStayOnDesktop(): boolean {
  try { return localStorage.getItem(STAY_KEY) === "1"; } catch { return false; }
}

export function setStayOnDesktop(): void {
  try { localStorage.setItem(STAY_KEY, "1"); } catch { /* ignore */ }
}

export function clearStayOnDesktop(): void {
  try { localStorage.removeItem(STAY_KEY); } catch { /* ignore */ }
}
